import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Management/NetworkList';

class Facebook extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="facebook"/>}/>
      </Switch>
    )
  }
}

module.exports = Facebook;



// WEBPACK FOOTER //
// ./routes/app/routes/management/facebook/index.js